import React from 'react';

export const TC = {
  bg:        'var(--bg-body)',
  card:      'var(--bg-card)',
  border:    'var(--border)',
  text:      'var(--text-primary)',
  muted:     'var(--text-muted)',
  dim:       'var(--text-secondary)',
  accent:    'var(--accent)',
  accentDim: 'rgba(77,142,240,0.10)',
  green:     '#10b981', greenDim:  'rgba(16,185,129,0.10)',
  amber:     '#fcd34d', amberDim:  'rgba(252,211,77,0.15)',
  red:       '#c0392b', redDim:    'rgba(192,57,43,0.10)',
  cyan:      '#0e7490', cyanDim:   'rgba(14,116,144,0.10)',
};

export function TBadge({ color, bg, children, style }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', fontSize: 11, fontWeight: 700,
      padding: '2px 7px', borderRadius: 6, color, background: bg,
      letterSpacing: '0.02em', ...style,
    }}>{children}</span>
  );
}

export function TCard({ children, style, onClick }) {
  return (
    <div onClick={onClick} style={{
      background: TC.card, border: `1px solid ${TC.border}`,
      borderRadius: 12, padding: '14px 16px', marginBottom: 10, ...style,
    }}>{children}</div>
  );
}

export function TOverlay({ onClose, children }) {
  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      zIndex: 200, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: TC.card, borderRadius: '16px 16px 0 0',
        width: '100%', maxWidth: 480, maxHeight: '85vh', overflowY: 'auto',
        padding: '16px 16px 48px', WebkitOverflowScrolling: 'touch',
      }}>
        <div style={{ width: 36, height: 4, borderRadius: 2, background: TC.dim, margin: '0 auto 16px' }} />
        {children}
      </div>
    </div>
  );
}
